import { createContext } from 'react';

import type { AnyRoute } from './generated/routeInfo';

export const RoutePatternContext = createContext<AnyRoute | undefined>(undefined);
